import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css'
import { toFormatPrice } from '../common/helpers/function';
import './Quotation.scss'
import CheckoutBlank from '../checkout/checkoutBlank'
import { _Api } from '../common/api/_call'
import { useTranslation } from 'react-i18next';
import { posquotation_head } from '../../components/common/Tablehead'
import DailySaleReportTableHead from '../Report/DailySaleReportTableHead'
import {
  getNextSortConfig,
  normalizeQuotationTableHead,
  sortQuotationRows,
} from './quotationTableConfig'
import CheckoutSell from '../checkout/checkoutSell'
import CheckoutPayment from '../checkout/checkoutPayment'
import { useSelector } from 'react-redux';
import DeleteModal from "../common/module/deletemodal";
import { QuotationDetailsSubtable } from './subtable/QuotationDetailsSubtable';
import $ from 'jquery';

const Quotation = () => {
  const navigate = useNavigate();
  const [, setdeletestatus] = useState(false)
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const { t } = useTranslation();
  const [newcolumndata, setnewcolumndata] = useState(posquotation_head)
  const [quotationid, setQuotationid] = useState()
  const [quotationlist, setQuotationlist] = useState([])
  const [UpdatedCart, setUpdatedCart] = useState();
  const [showcheckout, setShowcheckout] = useState('blank')
  const [showpayment, setShowpayment] = useState(false);
  const [searchproductstatus, setsearchproductstatus] = useState(false);
  const [filtername, setFiltername] = useState("");
  const [deleteparmission, setDeleteparmission] = useState(0)
  const [sortConfig, setSortConfig] = useState({
    columnIndex: 1,
    direction: 'desc',
  });
  const [excuteTable, setExcuteTable] = useState(false);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

  const activeTableColumns = newcolumndata?.length
    ? newcolumndata
    : posquotation_head;

  const sortedQuotationlist = useMemo(
    () => sortQuotationRows(quotationlist, sortConfig),
    [quotationlist, sortConfig]
  );

  const handleQuotationSort = (columnIndex) => {
    setSortConfig((current) => getNextSortConfig(current, columnIndex));
  };

  useEffect(() => {
    if (parmissiondatashow?.Quotation?.View)
      setDeleteparmission(parmissiondatashow?.Quotation?.Delete);
  }, [parmissiondatashow?.Quotation?.Add, parmissiondatashow?.Quotation?.Delete, parmissiondatashow?.Quotation?.View]);

  const callcolumns = async () => {
    try {
      const postdata = {
        name: 'report_quotation_tbl',
      }
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      )
      if (columnhead.code === 200) {
        setnewcolumndata(
          normalizeQuotationTableHead(columnhead?.data?.data)
        )
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }

  useEffect(() => {
    callcolumns()
  }, [])

  const collapseExpandedRows = () => {
    document.querySelectorAll('.table_btn_expand_col.rotate-90').forEach((el) => {
      el.classList.remove('rotate-90');
    });
  };

  const getquotationlist = useCallback(async (event) => {
    setExcuteTable(false);
    collapseExpandedRows();
    try {
      let postdata = {
        "type": event ? event : "",
        "search": filtername,
      }
      const res = await _Api(postdata, `api/v1/POS/quatation/getQuatationList`)
      if (res?.code === 200) {
        setQuotationlist(res?.data || []);
        setExcuteTable(true);
      } else {
        setQuotationlist([]);
        setExcuteTable(true);
      }
    }
    catch (err) {
      console.log(err, "err");
      setExcuteTable(true);
    }
  }, [filtername])

  const setSubTableQuotation = async (id) => {
    const expandBtn = document.querySelector(`#table-btn_${id}`);
    const row = document.querySelector(`#common-main-table-wrap-${id}`);
    if (!expandBtn) return;

    const classList_ = expandBtn.classList;

    if (classList_.contains('rotate-90')) {
      classList_.remove('rotate-90');
      const alllist_data = [...quotationlist];
      alllist_data
        .filter((item) => item.id === id)
        .forEach((result) => {
          result.subTabledata = null;
        });
      setQuotationlist(alllist_data);
    } else {
      classList_.add('rotate-90');
      const alllist_data = [...quotationlist];
      const postdata = {
        quotation_id: id,
      };
      const prioritydata = await _Api(
        postdata,
        'api/v1/POS/report/quotationDetails'
      );
      const html_ = QuotationDetailsSubtable(prioritydata, id, t);
      alllist_data
        .filter((item) => item.id === id)
        .forEach((result) => {
          result.subTabledata = html_;
        });
      setQuotationlist(alllist_data);

      const checkRowSub = setInterval(() => {
        const rowSub = document.querySelector(`#common-sub-table-wrap-${id}`);
        if (rowSub) {
          $(row).after(rowSub);
          clearInterval(checkRowSub);
        }
      }, 100);
    }
  };

  useEffect(() => {
    getquotationlist()
  }, [getquotationlist])

  const GetCartdetailorder = async (id) => {
    try {
      const postdata = {
        "quatation_id": id
      }
      let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`)
      if (res.code === 200) {
        setUpdatedCart(res?.data);
        setShowcheckout('sell');
        setQuotationid(id)
      } else {
        navigate('/app/pos/custom/customOrderDelivered')
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }

  const removequotation = async () => {
    try {
      let postdata = {
        "quatation_id": quotationid
      }
      let res = await _Api(postdata, `api/v1/POS/quatation/removeQuatation`)
      if (res.code === 200) {
        getquotationlist()
      }

    }
    catch (err) {
      console.log(err, 'err')
    }
  }

  const filterbyname = () => {
    getquotationlist();
  };

  const renderRefNoCell = (result) => (
    <td>
      {result?.ref_no ? <div>{result.ref_no}</div> : null}
      {result?.quo_no ? (
        <div
          className="link-color cursor-pointer"
          onClick={() => GetCartdetailorder(result?.id)}
        >
          {result.quo_no}
        </div>
      ) : (
        !result?.ref_no ? '-' : null
      )}
    </td>
  );

  const renderSkuCell = (result) => (
    <td
      className="sku-col table_btn_expand_col quotation-expand-arrow"
      onClick={() => setSubTableQuotation(result?.id)}
      id={`table-btn_${result?.id}`}
    >
      <img
        className="sku-col-arrow cursor-pointer"
        src={base_assets + '/images/icons/right_green_button.png'}
        alt=""
      />
      {result?.SKU ? result.SKU : '-'}
    </td>
  );

  const renderActionCell = (result) => (
    <td>
      <div className="customer-table-dropdown dropdown">
        <button
          className="btn-style dropdown-toggle"
          type="button"
          id={`dropdownMenuButton-${result?.id}`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img src={base_assets + 'images/icons/ellipsis-circular.png'} alt="" />
        </button>
        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${result?.id}`}>
          <li onClick={() => GetCartdetailorder(result?.id)}>
            <Link className="dropdown-item img-btn-hover svg-stroke-hover">
              <div className="dropdown-menu-img">
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 13.5H5.5M8 16V11" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M1 18V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H8.172C8.70239 1.00011 9.21101 1.2109 9.586 1.586L14.414 6.414C14.7891 6.78899 14.9999 7.29761 15 7.828V18C15 18.2652 14.8946 18.5196 14.7071 18.7071C14.5196 18.8946 14.2652 19 14 19H2C1.73478 19 1.48043 18.8946 1.29289 18.7071C1.10536 18.5196 1 18.2652 1 18Z" stroke="black" strokeWidth="2" strokeLinejoin="round" />
                  <path d="M8 1V7C8 7.26522 8.10536 7.51957 8.29289 7.70711C8.48043 7.89464 8.73478 8 9 8H15" stroke="black" strokeWidth="2" strokeLinejoin="round" />
                </svg>
              </div>
              {t("Add to Order")}
            </Link>
          </li>
          <li
            onClick={() => {
              if (result?.encoded_print) {
                window.open(result?.encoded_print, '_blank', 'noreferrer')
              }
            }}
          >
            <Link className="dropdown-item img-btn-hover svg-stroke-hover">
              <div className="dropdown-menu-img">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.26389 0.917969H15.7361C16.2434 0.917936 16.7315 1.11203 17.1003 1.46043C17.469 1.80884 17.6904 2.28514 17.7192 2.79164L17.7222 2.90408V4.58402L18.7917 4.58464C20.5639 4.58464 22 6.02075 22 7.79297V16.043C22 16.5697 21.7907 17.0749 21.4183 17.4474C21.0458 17.8198 20.5406 18.0291 20.0139 18.0291L17.7222 18.0285V19.0985C17.7222 19.6253 17.513 20.1304 17.1405 20.5029C16.768 20.8754 16.2629 21.0846 15.7361 21.0846H6.26389C5.73714 21.0846 5.23196 20.8754 4.8595 20.5029C4.48703 20.1304 4.27778 19.6253 4.27778 19.0985V18.0285L1.98611 18.0291C1.45936 18.0291 0.954186 17.8198 0.581718 17.4474C0.20925 17.0749 0 16.5697 0 16.043V7.79297C0 6.02075 1.43611 4.58464 3.20833 4.58464L4.27778 4.58402V2.90408C4.27774 2.39677 4.47184 1.90868 4.82024 1.53994C5.16865 1.17119 5.64495 0.949746 6.15144 0.921024L6.26389 0.917969ZM15.7361 13.4457H6.26389C6.14233 13.4457 6.02575 13.494 5.9398 13.58C5.85384 13.6659 5.80556 13.7825 5.80556 13.9041V19.0985C5.80556 19.3515 6.01089 19.5569 6.26389 19.5569H15.7361C15.8577 19.5569 15.9742 19.5086 16.0602 19.4226C16.1462 19.3367 16.1944 19.2201 16.1944 19.0985V13.9041C16.1944 13.7825 16.1462 13.6659 16.0602 13.58C15.9742 13.494 15.8577 13.4457 15.7361 13.4457ZM18.7917 6.11241H3.20833C2.76262 6.11241 2.33517 6.28947 2.02 6.60464C1.70484 6.9198 1.52778 7.34726 1.52778 7.79297V16.043C1.52778 16.296 1.73311 16.5013 1.98611 16.5013L4.27778 16.5007V13.9041C4.27778 13.3773 4.48703 12.8722 4.8595 12.4997C5.23196 12.1272 5.73714 11.918 6.26389 11.918H15.7361C16.2629 11.918 16.768 12.1272 17.1405 12.4997C17.513 12.8722 17.7222 13.3773 17.7222 13.9041V16.5007L20.0139 16.5013C20.1354 16.5013 20.252 16.453 20.338 16.3671C20.4239 16.2811 20.4722 16.1645 20.4722 16.043V7.79297C20.4722 7.34726 20.2952 6.9198 19.98 6.60464C19.6648 6.28947 19.2374 6.11241 18.7917 6.11241ZM15.7361 2.44575H6.26389C6.15313 2.44575 6.04612 2.48586 5.96265 2.55866C5.87918 2.63146 5.8249 2.73202 5.80983 2.84175L5.80556 2.90408V4.58402H16.1944V2.90408C16.1944 2.79332 16.1543 2.68632 16.0815 2.60284C16.0087 2.51937 15.9082 2.46509 15.7984 2.45002L15.7361 2.44575Z" fill="#2A2A2A" />
                </svg>
              </div>
              {t("print")}
            </Link>
          </li>
          <li
            className={deleteparmission ? '' : 'd-none'}
            data-bs-toggle="modal"
            data-bs-target="#delete-listedModal"
            onClick={() => setQuotationid(result?.id)}
          >
            <Link className="dropdown-item img-btn-hover svg-fill-hover">
              <div className="dropdown-menu-img">
                <svg width="15" height="16" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.25 3.6875H13.3125V2.75C13.3125 2.20299 13.0952 1.67839 12.7084 1.29159C12.3216 0.904799 11.797 0.6875 11.25 0.6875H6.75C6.20299 0.6875 5.67839 0.904799 5.29159 1.29159C4.9048 1.67839 4.6875 2.20299 4.6875 2.75V3.6875H0.75C0.600816 3.6875 0.457742 3.74676 0.352252 3.85225C0.246763 3.95774 0.1875 4.10082 0.1875 4.25C0.1875 4.39918 0.246763 4.54226 0.352252 4.64775C0.457742 4.75324 0.600816 4.8125 0.75 4.8125H1.6875V18.5C1.6875 18.8481 1.82578 19.1819 2.07192 19.4281C2.31806 19.6742 2.6519 19.8125 3 19.8125H15C15.3481 19.8125 15.6819 19.6742 15.9281 19.4281C16.1742 19.1819 16.3125 18.8481 16.3125 18.5V4.8125H17.25C17.3992 4.8125 17.5423 4.75324 17.6477 4.64775C17.7532 4.54226 17.8125 4.39918 17.8125 4.25C17.8125 4.10082 17.7532 3.95774 17.6477 3.85225C17.5423 3.74676 17.3992 3.6875 17.25 3.6875ZM5.8125 2.75C5.8125 2.50136 5.91127 2.2629 6.08709 2.08709C6.2629 1.91127 6.50136 1.8125 6.75 1.8125H11.25C11.4986 1.8125 11.7371 1.91127 11.9129 2.08709C12.0887 2.2629 12.1875 2.50136 12.1875 2.75V3.6875H5.8125V2.75ZM15.1875 18.5C15.1875 18.5497 15.1677 18.5974 15.1326 18.6326C15.0974 18.6677 15.0497 18.6875 15 18.6875H3C2.95027 18.6875 2.90258 18.6677 2.86742 18.6326C2.83225 18.5974 2.8125 18.5497 2.8125 18.5V4.8125H15.1875V18.5ZM7.3125 8.75V14.75C7.3125 14.8992 7.25324 15.0423 7.14775 15.1477C7.04226 15.2532 6.89918 15.3125 6.75 15.3125C6.60082 15.3125 6.45774 15.2532 6.35225 15.1477C6.24676 15.0423 6.1875 14.8992 6.1875 14.75V8.75C6.1875 8.60082 6.24676 8.45774 6.35225 8.35225C6.45774 8.24676 6.60082 8.1875 6.75 8.1875C6.89918 8.1875 7.04226 8.24676 7.14775 8.35225C7.25324 8.45774 7.3125 8.60082 7.3125 8.75ZM11.8125 8.75V14.75C11.8125 14.8992 11.7532 15.0423 11.6477 15.1477C11.5423 15.2532 11.3992 15.3125 11.25 15.3125C11.1008 15.3125 10.9577 15.2532 10.8523 15.1477C10.7468 15.0423 10.6875 14.8992 10.6875 14.75V8.75C10.6875 8.60082 10.7468 8.45774 10.8523 8.35225C10.9577 8.24676 11.1008 8.1875 11.25 8.1875C11.3992 8.1875 11.5423 8.24676 11.6477 8.35225C11.7532 8.45774 11.8125 8.60082 11.8125 8.75Z" fill="#FF5757" />
                </svg>
              </div>
              {t("Delete")}
            </Link>
          </li>
        </ul>
      </div>
    </td>
  );

  const renderQuotationRow = (result, index) => (
    <React.Fragment key={result?.id || index}>
      <tr id={`common-main-table-wrap-${result?.id}`}>
        <td>{index + 1}</td>
        <td>{result?.date ? result?.date : "-"}</td>
        <td>{result?.type ? result?.type : "-"}</td>
        <td>{result?.voucher_type ? result?.voucher_type : "-"}</td>
        {renderRefNoCell(result)}
        <td>{result?.customer ? result?.customer : "-"}</td>
        {renderSkuCell(result)}
        <td>{result?.location ? result?.location : "-"}</td>
        <td>{result?.qty ? result?.qty : "-"}</td>
        <td>{toFormatPrice(result.amount, { addSymbol: true })}</td>
        {renderActionCell(result)}
      </tr>
      {excuteTable ? (
        <>
          {typeof result.subTabledata === 'undefined'
            ? (result.subTabledata = '')
            : result.subTabledata}
        </>
      ) : null}
    </React.Fragment>
  );

  const renderQuotationTable = (tableId) => (
    <div
      className="main-body-main-table-wrap vertical-scroll-table quotation-table mt-4"
      id="table-scroll"
    >
      <table
        id={tableId}
        className="common-table first-row-gray w-100 "
      >
        <DailySaleReportTableHead
          tablehead={activeTableColumns}
          sortConfig={sortConfig}
          onSort={handleQuotationSort}
          arrowSort
        />
        <tbody>
          {sortedQuotationlist.length
            ? sortedQuotationlist.map((result, key) =>
                renderQuotationRow(result, key)
              )
            : null}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="main-body">
      <div className="main-body-row">
        <div className="main-body-row-left-col p-0 quotation">
          <div className="com-data-area">
            <div className="catalog-area-header-area detail-area-header">
              <div className="catalog-area-header-area-control">
                <div className="catalog-area-header-area-control-left">
                  <h1 className="heading">{t("QUOTATION")}</h1>
                </div>
                <div className="catalog-area-header-area-control-right">
                  <div className="com-search-area">
                    <input
                      type="text"
                      onChange={(e) => setFiltername(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && filterbyname()}
                      placeholder={t("Search By Invoice/SKU/Stock ID/Location")}
                    />
                    <img onClick={filterbyname} className="com-search-area-img" src={base_assets + "images/pos/icons/magnifying-glass.png"} alt="" />

                  </div>
                </div>
              </div>
            </div>
            <div className="com-data-area-inner bg-white">
              <div className="Dailysalereport-content-area-main quotation-main mt-0 mx-0">
                <ul
                  className="Dailysalereport-content-area-navbar nav-tabs quotation-main-navbar mt-4"
                  id="myTab"
                  role="tablist"
                >
                  <li
                    className="nav-item Dailysalereport-content-area-navbar-item quotation-main-navbar-item"
                    role="presentation"
                    onClick={() => getquotationlist("")}
                  >
                    <button
                      className="nav-link active Dailysalereport-content-area-navbar-item-link quotation-main-navbar-item-link"
                      id="Sale-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Sale"
                      type="button"
                      role="tab"
                      aria-controls="Sale"
                      aria-selected="true"
                    >
                      {t("ALL")}
                    </button>
                  </li>
                  <li
                    className="nav-item quotation-main-navbar-item"
                    role="presentation"
                    onClick={() => getquotationlist("custom_order")}
                  >
                    <button
                      className="nav-link quotation-main-navbar-item-link quotation-main-navbar-item-link-custom Dailysalereport-content-area-navbar-item-link"
                      id="Custom-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Custom"
                      type="button"
                      role="tab"
                      aria-controls="Custom"
                      aria-selected="false"
                    >
                      {t("Custom")}
                    </button>
                  </li>
                  <li
                    className="nav-item quotation-main-navbar-item"
                    role="presentation"
                    onClick={() => getquotationlist("repair_order")}
                  >
                    <button
                      className="nav-link quotation-main-navbar-item-link Dailysalereport-content-area-navbar-item-link"
                      id="Repair-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Repair"
                      type="button"
                      role="tab"
                      aria-controls="Repair"
                      aria-selected="false"
                    >
                      {t("Repair")}
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="Sale"
                    role="tabpanel"
                    aria-labelledby="Sale-tab"
                  >
                    {renderQuotationTable('quotaion_list_table')}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Custom"
                    role="tabpanel"
                    aria-labelledby="Custom-tab"
                  >
                    {renderQuotationTable('quotaion_list_table_custom_order')}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="Repair"
                    role="tabpanel"
                    aria-labelledby="Repair-tab"
                  >
                    {renderQuotationTable('quotaion_list_table_repair')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-body-row-right-col">
          {showcheckout === 'sell' ? (
            <CheckoutSell
              setShowcheckout={setShowcheckout}
              setdeletestatus={setdeletestatus}
              setUpdatedCart={setUpdatedCart}
              UpdatedCart={UpdatedCart}
              setShowpayment={setShowpayment}
              showpayment={showpayment}
              setsearchproductstatus={setsearchproductstatus}
              searchproductstatus={searchproductstatus}
            />
          ) : showcheckout === 'payment' ? (

            < CheckoutPayment UpdatedCart={UpdatedCart} setShowcheckout={setShowcheckout} quotationid={quotationid ? quotationid : ''} />
          ) : (
            <CheckoutBlank />
          )}
        </div>
      </div>
      <DeleteModal statement={"Quotation"} handler_delete={removequotation} />
    </div>

  )
}

export default Quotation;
